export const residentRegex = {
  CFP: /^\d{11}$|^\d{3}\.\d{3}\.\d{3}-\d{2}$/, // 브라질 CPF: 12345678901 또는 123.456.789-01 형식
  CNPJ: /^\d{14}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, // 브라질 CNPJ: 12345678901234 또는 00.000.000/0000-00 형식
  CN: /^\d{15}$|^\d{18}$|^[A-Z0-9]{10,12}$/, // 중국: 15자리, 18자리 주민번호 또는 10~12자리 EORI
  RFC: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/i, // 멕시코
};

// 숫자만 입력했는지 유효성 확인
export const validateNumber = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^\d+$/.test(value.trim());
};

// 전화번호 유효성 확인
export const validatePhone = (value?: string | null) => {
  if (!value?.trim()) return false;

  // 하이픈과 공백 제거 후 순수 숫자만으로 검증
  const cleanValue = value.trim().replace(/[-\s]/g, "");

  return [
    /^010-[0-9]{4}-[0-9]{4}$/, // 010 (하이픈 있음)
    /^01[1679]-[0-9]{3,4}-[0-9]{4}$/, // 011,016,017,018,019 (하이픈 있음)
    /^010[0-9]{4}[0-9]{4}$/, // 010 (하이픈 없음)
    /^01[1679][0-9]{3,4}[0-9]{4}$/, // 011,016,017,018,019 (하이픈 없음)
    /^82010[0-9]{4}[0-9]{4}$/, // 82 010
    /^8201[1679][0-9]{3,4}[0-9]{4}$/, // 82 011,016,017,018,019
    /^02-[0-9]{3}-[0-9]{4}$/, // 서울
    /^0[1-9]{2}-[0-9]{3}-[0-9]{4}$/, // 지역번호
    /^02[0-9]{3}[0-9]{4}$/, // 서울 (하이픈 없음)
    /^0[1-9]{2}[0-9]{3}[0-9]{4}$/, // 지역번호 (하이픈 없음)
  ].some((regexp) => regexp.test(cleanValue));
};

// 이메일 유효성 확인
export const validateEmail = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(value.trim());
};

// 인스타그램 ID 유효성 확인
export const validateInstagram = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /[^a-z0-9._]/g.test(value.trim());
};

// 할인코드 유효성 확인
export const validateDiscount = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^[a-zA-Z0-9-_]+$/.test(value.trim());
};

// 영어만 입력했는지 유효성 확인
export const validateEnglish = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^[\w\s\p{P}]*$/u.test(value.trim());
};

// 우편번호 유효성 확인
export const validateZip = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^[a-zA-Z0-9-_ ]+$/.test(value.trim());
};

// 해외 전화번호 확인
export const validateIntlPhone = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^[0-9+-]+$/.test(value.trim());
};

// 입력 문자 길이 확인
export const validateLength = ({ value, length }: { value?: string | null; length: number }) => {
  if (!value?.trim()) return false;
  return value.trim().length >= length;
};

// 생년월일 확인
export const validateBirth = (value?: string | null) => {
  if (!value?.trim()) return false;
  return /^(?:0[1-9]|1[0-2])\/(?:0[1-9]|[1-2][0-9]|3[0-1])\/[12][0-9]{3}$/.test(value.trim());
};
